export type ThemeId = "green" | "amber" | "cyan" | "purple" | "rose";

export type Theme = {
  id: ThemeId;
  label: string;
  hint: string;
};

export const themes: Theme[] = [
  { id: "green", label: "green", hint: "default phosphor · sonar" },
  { id: "amber", label: "amber", hint: "amber monitor · warning vibes" },
  { id: "cyan", label: "cyan", hint: "ice terminal · cold harbor" },
  { id: "purple", label: "purple", hint: "violet CRT · night shift" },
  { id: "rose", label: "rose", hint: "pink scanlines · for fun" },
];

const STORAGE_KEY = "jvnko-theme";

export function initTheme(): ThemeId {
  const saved = localStorage.getItem(STORAGE_KEY) as ThemeId | null;
  const id = themes.some((t) => t.id === saved) ? saved! : "green";
  applyTheme(id);
  return id;
}

export function applyTheme(id: ThemeId): void {
  document.documentElement.dataset.theme = id;
  localStorage.setItem(STORAGE_KEY, id);
}

export function currentTheme(): ThemeId {
  const id = document.documentElement.dataset.theme as ThemeId | undefined;
  return themes.some((t) => t.id === id) ? id! : "green";
}

export function themeHelp(): string {
  const cur = currentTheme();
  const rows = themes.map((t) => {
    const mark = t.id === cur ? "*" : " ";
    return `  ${mark} ${t.label.padEnd(8)} ${t.hint}`;
  });
  return ["themes  (/color <name>)", ...rows, "", "example: /color amber"].join("\n");
}

export function setTheme(name: string): string {
  const hit = themes.find((t) => t.id === name || t.label === name);
  if (!hit) return `color: unknown palette '${name}'\ntry /color`;
  applyTheme(hit.id);
  return `palette set to ${hit.label}`;
}
